<template>
  <div class="print-popup">
    <div v-for="user in usersFilteredWithTags"
         v-if="!isUserFiltered(user)"
         :key="user.id"
         class="user">
      <h4>Opgaveoversigt {{ activeSchoolYear.name }}</h4>
      <SubjectsDistributionUser
        :activeUserId="user.id"
        :showCloseCross="false">
      </SubjectsDistributionUser>
    </div>
    <transition name="modal">
      <DModal v-if="isPrintSettingsModal"
              :showClose="false"
              @close="$emit('close')">
        <div class="modal__content" slot="insertComponent">
          <div class="modal__content__close icon__bg-circle" @click="$emit('close')">
            <span class="icon-cross2"></span>
          </div>
          <h2>Print {{usersFilteredWithTags.length - filteredUsers.length}} undervisere</h2>
          <label class="print-form__label">Fravælg evt. undervisere</label>
          <ul class="user-list">
            <li class="user-list__item"
                :class="{'user-list__item--disabled': isUserFiltered(user)}"
                v-for="user in usersFilteredWithTags"
                :key="user.id"
                @click="toggleFilteredUser(user)">
              {{user.name}}
            </li>
          </ul>
          <div class="modal__content__buttons">
            <button @click="$emit('close')">Luk</button>
            <button class="bttn bttn-primary" @click="print">Print</button>
          </div>
        </div>
      </DModal>
    </transition>
  </div>
</template>


<script>
  import SubjectsDistributionUser from './SubjectsDistributionUser'
  import DModal from '../common/DModal'

  export default {
    components: {SubjectsDistributionUser, DModal},
    data () {
      return {
        isPrintSettingsModal: false,
        filteredUsers: []
      }
    },
    computed: {
      activeSchoolYear () {
        return this.$store.state.localActivatedSchoolYear
      },
      usersFilteredWithTags () {
        return this.$store.getters.usersFilteredWithTags
      },
      usersFilteredWithTagsFiltered () {
        return this.usersFilteredWithTags.filter(user => user)
      }
    },
    watch: {
      activeSchoolYear () {
        this.readAssignedHours()
        this.$store.dispatch('readSubjects', this.activeSchoolYear.id)
        this.$store.dispatch('readTasks', this.activeSchoolYear.id)
      }
    },
    methods: {
      isUserFiltered (user) {
        return this.filteredUsers.indexOf(user.id) > -1
      },
      toggleFilteredUser (user) {
        let idx = this.filteredUsers.indexOf(user.id)
        if (idx < 0) {
          this.filteredUsers.push(user.id)
        } else {
          this.filteredUsers.splice(idx, 1)
        }
      },
      readAssignedHours () {
        let schoolObj = {
          schoolId: window.SCHOOL.id,
          schoolYearId: this.activeSchoolYear.id
        }
        this.$store.dispatch('getUsers', window.SCHOOL.id, null)
        this.$store.dispatch('readUsersAssignedHours', schoolObj)
      },
      print () {
        // https://stackoverflow.com/a/57957227
        setTimeout(_ => {
          try {
            // Print for Safari browser
            document.execCommand('print', false, null)
          } catch (err) {
            window.print()
          }
          setTimeout(_ => {
            window.close()
          }, 1000)
        }, 0)
      }
    },
    mounted () {
      this.readAssignedHours()
      setTimeout(_ => {
        this.isPrintSettingsModal = true
      }, 500)
    }
  }
</script>

<style scoped>
  .print-form__label {
    color: #a2a3a6;
    font-size: 10px;
  }
  .print-popup {
    padding: 20px;
    background-color: #ffffff;
  }

  .user {
    background-color: #ffffff;
    margin-bottom: 1rem;
    padding: 1rem;
    max-width: 500px;
    border: 1px solid #e2e8f0;
  }

  .print-modal {
    position: fixed;
    top: 100px;
    right: 100px;
  }

  .modal__content {
    padding: 2rem;
    width: 420px;
    position: relative;
  }

  .modal__content h4 {
    text-transform: uppercase;
    margin: 1rem 0 2rem 0;
  }

  .modal__content__close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.5rem;
    padding: 0.5rem;
    cursor: pointer;
    color: grey;
    transition: 0.25s;
  }

  .modal__content__close:hover {
    color: var(--dark-blue);
  }

  .modal__content__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 2rem;
  }

  .modal__content__buttons button:last-child {
    margin-left: 1rem;
  }

  .user-list {
    max-height: 400px;
    overflow-y: auto;
    background: #fff;
  }

  .user-list__item {
    padding: 5px 10px;
    border-top: 1px solid white;
    cursor: pointer;
  }

  .user-list__item--disabled {
    background-color: rgba(250, 86, 90, .35);
  }

  @media print {
    .print-modal {
      display: none;
    }

    html, body {
      height: 100%;
      margin: 0;
    }

    .user {
      clear: both;
      page-break-after: always;
    }
  }

</style>



// WEBPACK FOOTER //
// SubjectsDistributionPrint.vue?7e097f99